 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import getOAuthPopupFeatures from './getOAuthPopupFeatures'













const getTokenFromSSO = (url) => {
  // It's possible we prematurely opened a popup named SSO at the URL about:blank to avoid popup blockers
  // Calling window.open again will get a reference to that popup
  // Then, we can update the href to the valid URL
  const popup = window.open(url, 'SSO', getOAuthPopupFeatures({width: 385, height: 550, top: 64}))
  if (!popup) return {error: 'Failed to open login popup'}
  popup.location.href = url
  let closeCheckerId
  return new Promise((resolve) => {
    const handler = (event) => {
      // an extension posted to the opener
      if (typeof event.data !== 'object') return
      const {token, error} = event.data
      if (!token && !error) return
      if (event.origin !== window.location.origin) return

      const params = new URLSearchParams(popup.location.search)
      const userId = params.get('userId')
      const isNewUser = params.get('isNewUser') === 'true'
      const isPatient0 = params.get('isPatient0') === 'true'

      window.clearInterval(closeCheckerId)
      _optionalChain([popup, 'optionalAccess', _ => _.close, 'call', _2 => _2()])
      window.removeEventListener('message', handler)

      if (userId) {
        resolve({token, ga4Args: {userId, isNewUser, isPatient0}})
      } else {
        resolve({error: error || 'userId is null'})
      }
    }

    closeCheckerId = window.setInterval(() => {
      if (_optionalChain([popup, 'optionalAccess', _3 => _3.closed])) {
        resolve({error: 'Error logging in. Did you close the popup window?'})
        window.clearInterval(closeCheckerId)
        window.removeEventListener('message', handler)
      }
    }, 100)
    window.addEventListener('message', handler)
  })
}

export default getTokenFromSSO
